$(function () {
    $('.start-overview__displaymore a')
        .on("click", function (e) {
            e.preventDefault();
            $('.start-overview__secondrow').show(200);
            $('.start-overview__displaymore').hide(200);
        })
});